export default "__VITE_ASSET__Cu7ryZyQ__"